!function() {
  "use strict";
  window.Auxito=window.Auxito || {};
  window.Auxito.StaticVehicle = window.Auxito.StaticVehicle || {};
  const staticVehicleApi = window.Auxito.StaticVehicle;
  const DESKTOP_SCROLL_OFFSET = 150;
  const DESKTOP_ACTIVE_OFFSET = 170;
  const DESKTOP_SCROLL_GAP = 64;
  const DESKTOP_STICKY_GAP = 0;
  let e = null, t = null, i = -1, n = 0, h = 0, desktopNavLockedIndex = -1;
  function o() {
    if (!e) {
      const t = Array.from(document.querySelectorAll(".static-vehicle__nav-item")), i = Array.from(document.querySelectorAll(".static-vehicle__category-section"));
      e = {
        nav: document.querySelector(".static-vehicle__secondary-nav"),
        navItemsArray: t,
        sectionsArray: i,
        sectionData: i.map(function(e) {
          return {
            element: e,
            offsetTop: e.offsetTop
          };
        })
      };
    }
    return e;
  }
  function r() {
    t && t.parentNode && t.parentNode.removeChild(t), t = null;
  }
  function s() {
    return window.innerWidth <= 768;
  }
  function getDesktopActiveOffset(e) {
    const t = e && e.getBoundingClientRect ? e.getBoundingClientRect() : null;
    return Math.max(DESKTOP_ACTIVE_OFFSET, Math.round(t ? t.bottom : 0) + DESKTOP_SCROLL_GAP + 12);
  }
  function getDesktopScrollTargetTop(e) {
    const t = e && e.getBoundingClientRect ? e.getBoundingClientRect() : null;
    return Math.max(DESKTOP_SCROLL_OFFSET, Math.round(t ? t.bottom : 0) + DESKTOP_SCROLL_GAP);
  }
  function getDesktopStickyTop() {
    const e = document.querySelector(".site-header-wrapper"), t = e && e.getBoundingClientRect ? e.getBoundingClientRect() : null;
    return Math.max(62, Math.round(t ? t.bottom : 0) + DESKTOP_STICKY_GAP);
  }
  function syncDesktopStickyTop() {
    const e = document.querySelector(".static-vehicle");
    e && e.style.setProperty("--sv-desktop-sticky-top", `${getDesktopStickyTop()}px`);
  }
  function scheduleDesktopStickyTopSync() {
    h && window.clearTimeout(h), h = window.setTimeout(function() {
      h = 0, syncDesktopStickyTop();
    }, 140);
  }
  function clearDesktopNavLock() {
    desktopNavLockedIndex = -1;
  }
  function lockDesktopNavIndex(e) {
    desktopNavLockedIndex = e > -1 ? e : -1;
  }
  function prepareDesktopStickyNavForScroll() {
    const e = o().nav;
    syncDesktopStickyTop();
    return e && !s() ? (e.dataset.originalTop || (e.dataset.originalTop = String(e.offsetTop)),
    e.classList.contains("sticky") || (e.classList.add("sticky"), t || (t = document.createElement("div"),
    t.className = "nav-placeholder", t.style.height = e.offsetHeight + "px", e.parentNode.insertBefore(t, e))),
    e) : e;
  }
  function a(e) {
    const t = o().navItemsArray;
    const n = e >= 0 && e < t.length ? e : -1;
    t.forEach(function(e, t) {
      e.classList.toggle("static-vehicle__nav-item--active", t === n);
    }), i = n;
  }
  function c() {
    const e = o(), i = e.nav, n = window.pageYOffset;
    let s, l = -1, u;
    syncDesktopStickyTop();
    if (i) for (i.dataset.originalTop || (i.dataset.originalTop = String(i.offsetTop)), 
    n > parseInt(i.dataset.originalTop, 10) ? (i.classList.add("sticky"), t || (t = document.createElement("div"), 
    t.className = "nav-placeholder", t.style.height = i.offsetHeight + "px", i.parentNode.insertBefore(t, i))) : (i.classList.remove("sticky"), 
    r()), u = getDesktopActiveOffset(i), s = 0; s < e.sectionData.length; s += 1) {
      if (e.sectionData[s].element.getBoundingClientRect().top <= u) l = s;
      else break;
    }
    desktopNavLockedIndex > -1 ? desktopNavLockedIndex < e.navItemsArray.length ? a(desktopNavLockedIndex) : clearDesktopNavLock() : l > -1 && a(l);
    scheduleDesktopStickyTopSync();
  }
  function l() {
    n || (n = window.requestAnimationFrame(function() {
      n = 0, c();
    }));
  }
  function u(e, t) {
    let i = 0;
    return function() {
      i || (e(), i = window.setTimeout(function() {
        i = 0;
      }, t));
    };
  }
  function d() {
    syncDesktopStickyTop();
    o(), s() || (c(), window.addEventListener("scroll", u(l, 16), {
      passive: !0
    })), window.addEventListener("resize", u(function() {
      const t = o().nav;
      syncDesktopStickyTop();
      s() || !t || t.classList.contains("sticky") || (t.dataset.originalTop = String(t.offsetTop)), 
      e && (e.sectionData = e.sectionsArray.map(function(e) {
        return {
          element: e,
          offsetTop: e.offsetTop
        };
      })), l();
    }, 150), {
      passive: !0
    }), window.addEventListener("mousedown", clearDesktopNavLock), window.addEventListener("touchstart", clearDesktopNavLock, {
      passive: !0
    }), window.addEventListener("wheel", clearDesktopNavLock, {
      passive: !0
    }), window.addEventListener("keydown", function(e) {
      /^(ArrowDown|ArrowUp|PageDown|PageUp|Home|End|Space| )$/.test(e.key || "") && clearDesktopNavLock();
    });
  }
  staticVehicleApi.refreshPageScrollCache = function() {
    clearDesktopNavLock(), e = null, i = -1, r();
    const t = document.querySelector(".static-vehicle__secondary-nav");
    t && (t.classList.remove("sticky"), t.removeAttribute("data-original-top"));
    s() || l();
  }, staticVehicleApi.scrollToSection = function(e, t) {
    const i = document.getElementById(e), n = o().navItemsArray.indexOf(t), r = prepareDesktopStickyNavForScroll();
    i && (n > -1 && (lockDesktopNavIndex(n), a(n)), window.scrollTo({
      top: window.pageYOffset + i.getBoundingClientRect().top - getDesktopScrollTargetTop(r),
      behavior: "smooth"
    }));
  }, "loading" === document.readyState ? document.addEventListener("DOMContentLoaded", d) : d();
}(), function() {
  "use strict";
  const e = window.AuxitoFitmentEngine || null, t = window.AuxitoVehicleUtils || null;
  if (!e) throw new Error("AuxitoFitmentEngine is required for static vehicle page.");
  const i = String(window.__AUXITO_VEHICLE_LIBRARY_VERSION__ || "260421").trim() || "260421", n = e.normalizeComparableLocation, o = e.dedupeStrings, r = e.buildDynamicRecordKey, s = e.createEmptyFilters, a = e.collectHandlesFromSourceUrls, c = e.readSessionJson, l = e.writeSessionJson, u = e.toSessionCacheKey, d = [ {
    legacyCategory: "LED Bulbs",
    title: "LED Bulbs",
    slug: "led-bulbs"
  }, {
    legacyCategory: "Lighting Assemblies",
    title: "Lighting Assemblies",
    slug: "lighting-assemblies"
  }, {
    legacyCategory: "Exterior Accessories",
    title: "Accessories & Kits",
    slug: "accessories-kits"
  }, {
    legacyCategory: "Interior Accessories",
    title: "Accessories & Kits",
    slug: "accessories-kits"
  } ], f = d.reduce((e, t) => (e[t.legacyCategory] = t.title, e), {}), g = d.map(function(e) {
    return e.slug;
  }).filter(Boolean);
  function m(e) {
    const t = {}, i = {};
    function n(e, n) {
      const o = function(e, t) {
        if (!t || "object" != typeof t) return null;
        const i = Te(e || t.key || t.label || "");
        if (!i) return null;
        const n = String(t.desktop || t.image || "").trim(), o = String(t.mobile || t.mobile_image || t.mobileImage || n).trim();
        return n || o ? {
          key: i,
          desktop: n || o,
          mobile: o || n,
          aliases: (Array.isArray(t.aliases) ? t.aliases : t.aliases ? [ t.aliases ] : []).map(Te).filter(Boolean)
        } : null;
      }(e, n);
      o && (t[o.key] = {
        desktop: o.desktop,
        mobile: o.mobile
      }, o.aliases.forEach(function(e) {
        i[e] || (i[e] = o.key);
      }));
    }
    return Array.isArray(e) ? e.forEach(function(e) {
      n(e && (e.key || e.label), e);
    }) : e && "object" == typeof e && Object.entries(e).forEach(function(e) {
      n(e[0], e[1]);
    }), {
      locationAssets: t,
      locationAssetAliases: i
    };
  }
  function h(e) {
    if (!e || "object" != typeof e) return null;
    const t = String(e.title || e.name || "").trim();
    return t ? {
      id: String(e.id || t).trim(),
      location: t,
      image: e.image || "",
      mobileImage: e.mobile_image || e.mobileImage || e.image || "",
      url: e.url || ""
    } : null;
  }
  function p(e) {
    if (!e || "object" != typeof e) return null;
    const t = String(e.slug || "").trim(), i = String(e.title || function(e) {
      return String(e || "").trim().split("-").filter(Boolean).map(function(e) {
        return e.charAt(0).toUpperCase() + e.slice(1);
      }).join(" ");
    }(t)).trim();
    return t && i ? {
      slug: t,
      title: i,
      subtitle: String(e.subtitle || "Universal").trim() || "Universal",
      resultsUrl: String(e.results_url || e.resultsUrl || "").trim(),
      activeIcon: String(e.active_icon || e.activeIcon || "").trim(),
      defaultIcon: String(e.default_icon || e.defaultIcon || "").trim(),
      cards: (Array.isArray(e.cards) ? e.cards : []).map(h).filter(Boolean)
    } : null;
  }
  function y(e) {
    return !e || "object" != typeof e || Array.isArray(e) ? {} : Object.entries(e).reduce(function(e, t) {
      const i = String(t[0] || "").trim(), n = String(t[1] || "").trim();
      return i && n && (e[i] = n), e;
    }, {});
  }
  const v = function() {
    const t = (i = "vehicle11-static-config", e.parseJsonScriptById(i, "vehicle11 static config") || {});
    var i;
    const n = (Array.isArray(t.categories) ? t.categories : []).map(p).filter(Boolean), o = m(t.location_assets || t.locationAssets || {}), r = function(e) {
      const t = {};
      if (!e || "object" != typeof e || Array.isArray(e)) return t;
      return Object.entries(e).forEach(function(e) {
        const i = String(e[0] || "").trim(), n = e[1];
        if (!i || !n || "object" != typeof n) return;
        const o = String(n.image || n.desktop || "").trim(), r = String(n.thumb || n.mobile || n.image || n.desktop || "").trim();
        (o || r) && (t[i] = {
          image: o || r,
          thumb: r || o
        });
      }), t;
    }(t.location_card_assets || t.locationCardAssets || {}), s = y(t.location_card_aliases || t.locationCardAliases || {}), a = function(e) {
      if (!e || "object" != typeof e || Array.isArray(e)) return {};
      return Object.entries(e).reduce(function(e, t) {
        const i = String(t[0] || "").trim(), n = t[1];
        if (!i || !n || "object" != typeof n) return e;
        const o = String(n.active || n.active_icon || n.activeIcon || "").trim(), r = String(n.default || n.default_icon || n.defaultIcon || "").trim();
        return o || r ? (e[i] = {
          active: o || r,
          default: r || o
        }, e) : e;
      }, {});
    }(t.category_icons || t.categoryIcons || {}), c = y(t.category_fallback_asset_keys || t.categoryFallbackAssetKeys || {});
    return {
      version: Number(t.version || 1),
      categories: n,
      locationAssets: o.locationAssets,
      locationAssetAliases: o.locationAssetAliases,
      locationCardAssets: r,
      locationCardAliases: s,
      categoryIcons: a,
      categoryFallbackAssetKeys: c
    };
  }(), _ = v.locationCardAssets || {}, b = v.locationCardAliases || {}, S = v.categoryIcons || {}, w = v.categoryFallbackAssetKeys || {}, k = function() {
    const t = e.readArtifactsConfig("search-result-artifacts-config") || {};
    return {
      fitmentShardBaseUrl: String(t.fitmentShardBaseUrl || "").trim(),
      fitmentShardVersion: String(t.fitmentShardVersion || i).trim() || i
    };
  }(), A = window.AuxitoFitmentContext || null, L = v.categories.reduce((e, t) => (e[t.slug] = t, 
  e), {}), C = Object.assign({}, {
    "led-bulbs": {
      active: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/icon-Y1.png?v=1757405031",
      default: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/icon-B1.png?v=1757405031"
    },
    "off-road-lights": {
      active: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/icon-Y2.png?v=1757405031",
      default: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/icon-B2.png?v=1757405031"
    },
    "tire-inflator": {
      active: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/icon-Y4.png?v=1757405031",
      default: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/icon-B4.png?v=1757405031"
    },
    "jump-starter": {
      active: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/icon-Y3.png?v=1757405031",
      default: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/icon-B3.png?v=1757405031"
    },
    "car-vacuum": {
      active: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/icon-Y5.png?v=1757405031",
      default: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/icon-B5.png?v=1757405031"
    },
    "lighting-assemblies": {
      active: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/icon-Y6.png?v=1757405031",
      default: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/icon-B6.png?v=1757405031"
    },
    "accessories-kits": {
      active: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/icon-Y7.png?v=1757405031",
      default: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/icon-B7.png?v=1757405031"
    }
  }, S), j = C["led-bulbs"] || Object.values(C)[0] || {
    active: "",
    default: ""
  };
  const M = function() {
    const e = [], t = {};
    return d.forEach(function(i) {
      if (!i || !i.slug || t[i.slug]) return;
      const n = C[i.slug] || j;
      e.push({
        title: i.title,
        slug: i.slug,
        activeIcon: n.active,
        defaultIcon: n.default,
        isDynamic: !0
      }), t[i.slug] = !0;
    }), v.categories.forEach(function(i) {
      if (!i || !i.slug || t[i.slug]) return;
      const n = C[i.slug] || j;
      e.push({
        title: i.title,
        slug: i.slug,
        activeIcon: i.activeIcon || n.active,
        defaultIcon: i.defaultIcon || n.default,
        isDynamic: !1
      }), t[i.slug] = !0;
    }), e;
  }(), P = M.reduce((e, t, i) => (e[t.slug] = i, e), {}), B = M.reduce((e, t) => (e[t.slug] = t, 
  e), {}), E = M.reduce((e, t) => (e[t.title] || (e[t.title] = t), e), {}), T = v.categories.map(function(e) {
    return e.slug;
  }).filter(Boolean), I = {
    "off-road-lights": "/collections/led-off-road-lights",
    "jump-starter": "/collections/portable-jump-starter",
    "tire-inflator": "/collections/auxito-tire-inflators"
  }, U = Object.assign({}, {
    "High Beam - Off-road Use": {
      image: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/PC-1-1_High_Beam_-Off-road_Use.jpg?v=1757407577",
      thumb: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/1-1_High_Beam_-Off-road_Use.png?v=1757409841"
    },
    "Low Beam - Off-road Use": {
      image: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/PC-1-2_Low_Beam_-_Off-road_Use.jpg?v=1757407577",
      thumb: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/1-2_Low_Beam_-_Off-road_Use.png?v=1757409841"
    },
    "50W 6ohm Load Resistors": {
      image: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/PC-1-3_50W_6ohm_Load_Resistors.jpg?v=1757407577",
      thumb: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/1-3_50W_6ohm_Load_Resistors.png?v=1757409841"
    },
    "Back Up": {
      image: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/PC-1-4_Back_Up.jpg?v=1757407577",
      thumb: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/1-4_Back_Up.png?v=1757409842"
    },
    Brake: {
      image: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/PC-1-5_Brake.jpg?v=1757407577",
      thumb: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/1-5_Brake.png?v=1757409842"
    },
    "Center High Mount Stop": {
      image: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/PC-1-6_Center_High_Mount_Stop.jpg?v=1757407578",
      thumb: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/1-6_Center_High_Mount_Stop.png?v=1757409841"
    },
    "Front Fog": {
      image: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/PC-1-7_Front_Fog.jpg?v=1757407577",
      thumb: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/1-7_Front_Fog.png?v=1757409841"
    },
    "Front Side Marker": {
      image: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/PC-1-8_Front_Side_Marker.jpg?v=1757407577",
      thumb: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/1-8_Front_Side_Marker.png?v=1757409841"
    },
    "Front Turn Signal": {
      image: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/PC-1-9_Front_Turn_Signal.jpg?v=1757407577",
      thumb: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/1-9_Front_Turn_Signal.png?v=1757409841"
    },
    "License Plate": {
      image: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/PC-1-10_License_Plate.jpg?v=1757407577",
      thumb: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/1-10_License_Plate.png?v=1757409841"
    },
    "Luggage Compartment": {
      image: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/PC-1-11_Luggage_Compartment.jpg?v=1757407577",
      thumb: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/1-11_Luggage_Compartment.png?v=1757409841"
    },
    Parking: {
      image: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/PC-1-12_Parking.jpg?v=1757407577",
      thumb: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/1-12_Parking.png?v=1757409841"
    },
    "Rear Side Marker": {
      image: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/PC-1-13_Rear_Side_Marker.jpg?v=1757407577",
      thumb: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/1-13_Rear_Side_Marker.png?v=1757409841"
    },
    "Rear Turn Signal": {
      image: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/PC-1-14_Rear_Turn_Signal.jpg?v=1757407577",
      thumb: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/1-14_Rear_Turn_Signal.png?v=1757409841"
    },
    "Side Marker": {
      image: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/PC-1-15_Side_Marker.jpg?v=1757407577",
      thumb: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/1-15_Side_Marker.png?v=1757409841"
    },
    Tail: {
      image: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/PC-1-16_Tail.jpg?v=1757407577",
      thumb: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/1-16_Tail.png?v=1757409841"
    },
    "7in Driving Lights": {
      image: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/PC-2-1_7in_Driving_Lights.jpg?v=1757469482",
      thumb: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/2-1_7in_Driving_Lights.png?v=1757469493"
    },
    "License Plate Light": {
      image: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/PC-6-1_License_Plate_Light.jpg?v=1757470145",
      thumb: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/6-1_License_Plate_Light.png?v=1757470154"
    },
    "Side Mirror Light": {
      image: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/PC-6-2_Side_Mirror_Light.jpg?v=1757470144",
      thumb: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/6-2_Side_Mirror_Light.png?v=1757470154"
    },
    "Tail Light": {
      image: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/PC-6-3_Tail_Light.jpg?v=1757470145",
      thumb: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/6-3_Tail_Light.png?v=1757470155"
    },
    "Third Brake Light": {
      image: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/PC-6-4_Third_Brake_Light.jpg?v=1757470145",
      thumb: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/6-4_Third_Brake_Light.png?v=1757470154"
    },
    "Lid Armrest Cover": {
      image: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/PC-7-1_Lid_Armrest_Cover.jpg?v=1757470279",
      thumb: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/7-1_Lid_Armrest_Cover.png?v=1757470269"
    },
    "Seat Cover Full Set": {
      image: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/PC-7-2_Seat_Cover_Full_Set.jpg?v=1757470279",
      thumb: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/7-2_Seat_Cover_Full_Set.png?v=1757470269"
    }
  }, _), O = Object.assign({}, {
    "high beam - off-road use": {
      desktop: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/PC-1-1_High_Beam_-Off-road_Use_735d34a0-dffa-4e98-9f83-6ef37bfe92f9.jpg?v=1774848132",
      mobile: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/M-1-1_High_Beam_-Off-road_Use_c5bcb7f2-5121-4bfc-bea8-685c09b32fe3.jpg?v=1774847830"
    },
    "low beam - off-road use": {
      desktop: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/PC-1-2_Low_Beam_-_Off-road_Use_3f39549d-455e-4c82-8560-c85911fea91c.jpg?v=1774848516",
      mobile: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/M-1-2_Low_Beam_-_Off-road_Use_23df5bb6-9007-4cb0-82d0-13e3dcc7d318.jpg?v=1774848150"
    },
    "50w 6ohm load resistors": {
      desktop: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/PC-1-3_50W_6ohm_Load_Resistors_a5dbc72e-e718-40e9-bf82-07af29cb5868.jpg?v=1774848536",
      mobile: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/M-1-3_50W_6ohm_Load_Resistors_1295bbb9-dfca-4311-a256-7c92a7158653.jpg?v=1774847986"
    },
    "back up": {
      desktop: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/PC-1-4_Back_Up_699c5c8f-bdb6-409e-bc4a-a1fc948572d3.jpg?v=1774848401",
      mobile: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/M-1-4_Back_Up_9095429e-4d08-4d32-955c-2ca9e832223a.jpg?v=1774847929"
    },
    brake: {
      desktop: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/PC-1-5_Brake_8d5503fd-903a-4094-8d97-073728498cc8.jpg?v=1774856286",
      mobile: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/M-1-5_Brake_d25bb413-928a-4e75-b73d-9b3f1702289c.jpg?v=1774856286"
    },
    "center high mount stop": {
      desktop: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/PC-1-6_Center_High_Mount_Stop_93284e45-45cd-42b2-9172-33c7440e4685.jpg?v=1774848468",
      mobile: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/M-1-6_Center_High_Mount_Stop_98518e45-b69e-43c1-acf5-884dcaec96c7.jpg?v=1774848070"
    },
    "front fog": {
      desktop: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/PC-1-7_Front_Fog_99bd2e90-6718-475c-9416-c233e440b4e4.jpg?v=1774847850",
      mobile: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/M-1-7_Front_Fog_975347f3-bba8-4668-96c1-a0ef23405b17.jpg?v=1774847940"
    },
    "front side marker": {
      desktop: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/PC-1-8_Front_Side_Marker_8ceffbef-ae5e-4ad7-98b7-b0ea02504418.jpg?v=1774848107",
      mobile: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/M-1-8_Front_Side_Marker_e7022b7c-f4b0-44d1-b0e9-4cdc8c99fab6.jpg?v=1774847770"
    },
    "front turn signal": {
      desktop: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/PC-1-9_Front_Turn_Signal_bc851314-aefc-498e-8b5c-2bd43c8bf8f5.jpg?v=1774848228",
      mobile: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/M-1-9_Front_Turn_Signal_0ae74ae8-269f-475c-b60a-9335f1cefe7b.jpg?v=1774847917"
    },
    "license plate": {
      desktop: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/PC-1-10_License_Plate_c949bc11-3cbb-43fd-b20c-ec1ac3d2ca67.jpg?v=1774847904",
      mobile: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/M-1-10_License_Plate_dbbf4a51-4d1b-4ca7-8aaf-db5242f9705d.jpg?v=1774847807"
    },
    "luggage compartment": {
      desktop: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/PC-1-11_Luggage_Compartment_25261588-9648-4c51-9c03-4963884c492c.jpg?v=1774848395",
      mobile: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/M-1-11_Luggage_Compartment_f9cb2225-a20a-487a-aea3-dbe9d598fcec.jpg?v=1774847789"
    },
    parking: {
      desktop: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/PC-1-12_Parking_73169ed4-f5d4-45ff-aab9-838a41a1f493.jpg?v=1774848089",
      mobile: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/M-1-12_Parking_7a18f838-0e15-40a9-8c89-68c17e178257.jpg?v=1774848170"
    },
    "rear side marker": {
      desktop: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/PC-1-13_Rear_Side_Marker_580dc915-b1eb-4735-8b28-d80dff262f36.jpg?v=1774848328",
      mobile: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/M-1-13_Rear_Side_Marker_61818bc6-a2a0-4db3-871a-527119bd283c.jpg?v=1774847910"
    },
    "rear turn signal": {
      desktop: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/PC-1-14_Rear_Turn_Signal_8f796f4a-3b6b-4bb9-84be-1ef59adff037.jpg?v=1774848310",
      mobile: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/M-1-14_Rear_Turn_Signal_71c6ccf3-6d55-49b1-87c6-c60a65c901c7.jpg?v=1774847972"
    },
    "side marker": {
      desktop: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/PC-1-15_Side_Marker_a8a7674a-4d63-46e7-8707-20e27caafeb1.jpg?v=1774847935",
      mobile: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/M-1-15_Side_Marker_831fe13f-0a00-40ea-8c21-55467220f3ec.jpg?v=1774847899"
    },
    tail: {
      desktop: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/PC-1-16_Tail_fcf84771-f15a-46d2-9f6f-5c74c9ab0540.jpg?v=1774848286",
      mobile: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/M-1-16_Tail_00bc447b-4c4d-492a-af9d-b4feb8c83097.jpg?v=1774847892"
    },
    "license plate light": {
      desktop: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/PC-6-1_License_Plate_Light_54c69071-c71c-4ca5-a5cc-7776f7728fa7.jpg?v=1774842726",
      mobile: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/M-6-1_License_Plate_Light_6cb05ad1-8073-4f12-81bc-e819c3d12e10.jpg?v=1774842726"
    },
    "side mirror light": {
      desktop: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/PC-6-2_Side_Mirror_Light_3aa14489-2a1f-4d6a-ba4c-2371c46f0acb.jpg?v=1774847922",
      mobile: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/M-6-2_Side_Mirror_Light_fe31489c-656f-4813-bff5-261f0742b1ad.jpg?v=1774847867"
    },
    "tail light": {
      desktop: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/PC-6-3_Tail_Light_b8859e36-7fad-4452-b0bd-73097eb9c4b5.jpg?v=1774842726",
      mobile: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/M-6-3_Tail_Light_4c40ac37-9209-428d-9ce9-7a36908dc24b.jpg?v=1774842726"
    },
    "third brake light": {
      desktop: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/PC-6-4_Third_Brake_Light_695c9b08-a2fc-4622-9837-0527533d31af.jpg?v=1774842725",
      mobile: "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/M-6-4_Third_Brake_Light_212bddff-12d2-42b3-854e-ec66a240fd57.jpg?v=1774842726"
    }
  }, v.locationAssets || {}), F = Object.assign({
    "automatic transmission indicator light bulbs": "automatic transmission indicator",
    "check engine light": "check engine",
    "cruise control": "cruise control indicator",
    "electronic traction control": "electronic traction control indicator",
    "hot engine": "hot engine indicator",
    "seat belt warning light": "seat belt warning",
    "map light": "map",
    "map lights": "map",
    "dome light": "dome",
    "dome lights": "dome",
    "front dome": "dome",
    "rear dome": "dome",
    "rear reading light": "rear reading",
    "interior door light": "interior door",
    "engine compartment light": "engine compartment",
    "daytime running lights": "daytime running",
    "roof marker lights": "roof marker",
    "top clearance light": "clearance",
    "headlight bulb": "headlight bulbs",
    "headlight bulbs": "headlight bulbs",
    headlight: "headlight bulbs",
    "ash tray light bulb": "ash tray",
    "brake light bulb": "brake",
    "cargo area": "luggage compartment",
    "clearance light bulb": "clearance",
    bundles: "roof marker",
    courtesy: "map",
    "courtesy lights": "map",
    "door mirror illumination": "side mirror light",
    "engine compartment light bulb": "engine compartment",
    clock: "instrument panel",
    fog: "front fog",
    "front clearance and identification light bulb": "roof marker",
    "front inner turn signal": "front turn signal",
    "front inner turn signal lights": "front turn signal",
    "front outer turn signal": "front turn signal",
    "front outer turn signal lights": "front turn signal",
    "front parking": "parking",
    "high beam and low beam - off-road use": "headlight bulbs",
    "inner back-up reverse light": "back up",
    "inner brake": "brake",
    "inner tail": "tail",
    "inner tail lights": "tail",
    "mirror clearance light bulb": "side mirror light",
    "outer back-up reverse light": "back up",
    "outer brake": "brake",
    "outer tail": "tail",
    "puddle light bulb": "side mirror light",
    reading: "rear reading",
    "rear parking": "back parking",
    "rear turn signal lights&brake light&tail light": "rear turn signal",
    "side marker light": "side marker",
    "side mirror signal": "side mirror light",
    "low beam&fog lights": "front fog",
    parking: "front parking",
    "parking lights": "front parking",
    "cargo box": "luggage compartment",
    trunk: "luggage compartment",
    "trunk lights/cargo lights": "luggage compartment",
    "turn signal": "front turn signal",
    "turn signal light bulb-front inner": "front turn signal",
    "upper tail": "tail",
    "lower tail": "tail"
  }, v.locationAssetAliases || {}), x = Object.assign({}, {
    "Headlight Bulbs": "High Beam - Off-road Use",
    "High Beam": "High Beam - Off-road Use",
    "Low Beam": "Low Beam - Off-road Use",
    "Back-Up Reverse Light": "Back Up",
    "Backup Lights": "Back Up",
    "Brake Tail Lights": "Brake",
    "Fog Lights": "Front Fog",
    "Front Side Marker Lights": "Front Side Marker",
    "Rear Side Marker Lights": "Rear Side Marker",
    "Front Turn Signal Lights": "Front Turn Signal",
    "Rear Turn Signal Lights": "Rear Turn Signal",
    "License Plate Lights": "License Plate",
    "Tail Lights": "Tail",
    "3rd Brake Lights": "Third Brake Light",
    "Mirror Glass": "Side Mirror Light",
    "Console Cover": "Lid Armrest Cover",
    "Window Switches": "Lid Armrest Cover",
    "Exterior Accessories": "Seat Cover Full Set",
    "Interior Accessories": "Lid Armrest Cover",
    "7 Inch Driving Lights": "7in Driving Lights",
    "7in Driving Light": "7in Driving Lights"
  }, b), $ = Object.assign({}, {
    "LED Bulbs": "High Beam - Off-road Use",
    "Off Road Lights": "7in Driving Lights",
    "Lighting Assemblies": "License Plate Light",
    "Accessories & Kits": "Lid Armrest Cover"
  }, w), N = U["High Beam - Off-road Use"] || Object.values(U)[0] || {
    image: "",
    thumb: ""
  }, R = Object.keys($).reduce(function(e, t) {
    const i = $[t];
    return i && U[i] && (e[t] = U[i]), e;
  }, {}), q = i + "-p5", D = "auxito:search-source:" + q + ":", H = "auxito:search-selection:" + q + ":", V = "/pages/search-result", K = "(max-width: 768px)";
  let W = null, G = "", X = 0, Y = 0;
  const z = new Map, J = new Map, Q = new Set, Z = new Map, ee = new Map, te = new WeakMap, ie = new WeakMap;
  let ne = null;
  const oe = Object.entries(f).reduce((e, t) => {
    const i = t[0], n = t[1];
    return n && !e[n] && (e[n] = i), e;
  }, {}), re = [ "Most Popular", "Ultra-High Brightness", "Compact Design", "Smallest Design", "Wireless Installation", "Active Cooling", "No Adapter Required", "Built-in Fan", "Build-in Fan" ], se = {
    "LED Bulbs": !0,
    Lights: !0,
    "Headlight Bulbs": !0,
    Headlights: !0,
    "Forward Lighting": !0,
    "LED Headlights": !0,
    "Fan-equipped": !0,
    "External Driver": !0,
    "Fixed-angle": !0,
    IP67: !0
  };
  function ae(e) {
    return String(null == e ? "" : e).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
  }
  function ce(e) {
    return e ? 0 === String(e).indexOf("//") ? "https:" + e : String(e) : "";
  }
  function le(e, t, i) {
    const n = ce(e);
    if (!n) return '<div class="static-vehicle__product-bg"></div>';
    const o = i && "object" == typeof i ? i : {}, r = "eager" === o.loading ? "eager" : "lazy";
    let s = "auto";
    "high" !== o.fetchPriority && "low" !== o.fetchPriority || (s = o.fetchPriority);
    return `\n      <span class="static-vehicle-progressive-image" data-progressive-image>\n        <img class="static-vehicle-progressive-image__blur" src="${ae(function(e) {
      const t = ce(e);
      if (!t) return "";
      try {
        const e = new URL(t, window.location.origin);
        return e.searchParams.set("width", "24"), e.toString();
      } catch (e) {
        return t;
      }
    }(n))}" alt="" aria-hidden="true" decoding="async" loading="eager">\n        <img data-src="${ae(n)}" alt="${ae(t)}" class="static-vehicle__product-main static-vehicle-progressive-image__main js-static-vehicle-progressive-image" loading="${r}" fetchpriority="${s}" decoding="async">\n      </span>\n    `;
  }
  function ue() {
    return window.performance && "function" == typeof window.performance.now ? window.performance.now() : Date.now();
  }
  function de(e) {
    return new Promise(t => {
      if (!e || e.complete) return void t();
      const i = () => t();
      e.addEventListener("load", i, {
        once: !0
      }), e.addEventListener("error", i, {
        once: !0
      });
    });
  }
  function fe(e, t) {
    if (!e || "true" === e.dataset.progressiveStarted) return;
    const i = ue();
    Promise.race([ de(t), new Promise(e => {
      window.setTimeout(e, 160);
    }) ]).then(() => {
      e.isConnected && window.requestAnimationFrame(() => {
        if (e.isConnected) if (e.dataset.src && !e.getAttribute("src")) e.dataset.progressiveStarted = "true", 
        e.dataset.progressiveBatchStartedAt = String(i), e.setAttribute("src", e.dataset.src); else if (e.complete && e.naturalWidth > 0) {
          const t = e.parentElement, n = ue() - i, o = Math.max(0, 180 - n);
          t && window.setTimeout(() => {
            t.classList.add("is-loaded");
          }, o);
        }
      });
    });
  }
  function ge(e, t, i) {
    const n = 0 === t && i < ("mobile" === e ? 4 : 5);
    return {
      loading: n ? "eager" : "lazy",
      fetchPriority: n ? "high" : "low"
    };
  }
  function me(e) {
    if (!e || !e.querySelectorAll) return;
    const t = function(e) {
      return e ? e.classList && e.classList.contains("static-vehicle__mobile-content") ? e : "function" == typeof e.closest ? e.closest(".static-vehicle__mobile-content") : null : null;
    }(e), i = function(e) {
      if (!window.IntersectionObserver) return null;
      const t = (e, t) => {
        e.forEach(e => {
          if (!e.isIntersecting && e.intersectionRatio <= 0) return;
          const i = e.target, n = i.parentElement, o = n ? n.querySelector(".static-vehicle-progressive-image__blur") : null;
          t.unobserve(i), i.dataset.progressiveObserved = "false", fe(i, o);
        });
      };
      if (!e) return ne || (ne = new IntersectionObserver((e, i) => {
        t(e, i);
      }, {
        root: null,
        rootMargin: "280px 0px 360px 0px",
        threshold: .01
      })), ne;
      if (ie.has(e)) return ie.get(e);
      const i = new IntersectionObserver((e, i) => {
        t(e, i);
      }, {
        root: e,
        rootMargin: "220px 0px 320px 0px",
        threshold: .01
      });
      return ie.set(e, i), i;
    }(t);
    e.querySelectorAll(".js-static-vehicle-progressive-image").forEach(e => {
      const t = e.parentElement, n = t ? t.querySelector(".static-vehicle-progressive-image__blur") : null;
      if ("true" === e.dataset.progressiveBound) return void (e.complete && e.naturalWidth > 0 && t && t.classList.add("is-loaded"));
      e.dataset.progressiveBound = "true";
      const o = e => {
        if (t) {
          const i = ue() - e, n = Math.max(0, 180 - i);
          window.setTimeout(() => {
            t.classList.add("is-loaded");
          }, n);
        }
      };
      e.addEventListener("load", () => {
        const t = Number(e.dataset.progressiveBatchStartedAt || ue());
        o(t);
      }, {
        once: !0
      }), e.addEventListener("error", () => {
        const t = Number(e.dataset.progressiveBatchStartedAt || ue());
        o(t);
      }, {
        once: !0
      });
      "eager" === e.getAttribute("loading") || "high" === e.getAttribute("fetchpriority") || !i ? fe(e, n) : "true" !== e.dataset.progressiveObserved && (e.dataset.progressiveObserved = "true", 
      i.observe(e));
    });
  }
  function he(e, t) {
    const i = c(u(e, t));
    return Array.isArray(i) ? i : null;
  }
  function pe(e, t, i) {
    Array.isArray(i) && l(u(e, t), i);
  }
  function ye(e) {
    if (t && "function" == typeof t.normalizeVehicle) return t.normalizeVehicle(e);
    if (!e) return null;
    const i = {
      year: String(e.year || "").trim(),
      make: String(e.make || "").trim(),
      model: String(e.model || "").trim()
    };
    return i.year && i.make && i.model ? i : null;
  }
  function ve() {
    return function() {
      const e = new URLSearchParams(window.location.search);
      return ye({
        year: e.get("year"),
        make: e.get("make"),
        model: e.get("model")
      });
    }() || (window.AuxitoVehicleUtils && "function" == typeof window.AuxitoVehicleUtils.getCurrentVehicle ? ye(window.AuxitoVehicleUtils.getCurrentVehicle()) : null);
  }
  function _e(e) {
    return [ e && e.year, e && e.make, e && e.model ].filter(Boolean).join(" ");
  }
  function be(e) {
    const t = _e(e);
    return t ? `${t} Accessories & Parts` : "Vehicle Accessories & Parts";
  }
  function Se(e) {
    return "static::" + String(e || "").trim().toLowerCase();
  }
  function we(e) {
    const t = String(e || "").trim().toLowerCase(), i = t ? L[t] : null;
    return je(i && i.resultsUrl ? i.resultsUrl : I[t] || "");
  }
  function ke(e) {
    if (e && "object" == typeof e) {
      if (e.categorySlug) return String(e.categorySlug).trim();
      if (e.staticCategorySlug) return String(e.staticCategorySlug).trim();
      if (e.slug) return String(e.slug).trim();
    }
    const t = e && "object" == typeof e ? e.categoryName || e.title || "" : e;
    return E[t] ? E[t].slug : String(t || "").toLowerCase().replace(/&/g, "and").replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
  }
  function getVehicleCategorySortRank(e) {
    const t = ke(e), i = Object.prototype.hasOwnProperty.call(P, "led-bulbs") && P["led-bulbs"] >= 0 ? P["led-bulbs"] : 0;
    if ("off-road-lights" === t) return i + 1;
    if (!Object.prototype.hasOwnProperty.call(P, t)) return Number.MAX_SAFE_INTEGER;
    const n = P[t];
    return -1 === n ? Number.MAX_SAFE_INTEGER : n > i ? n + 1 : n;
  }
  function sortVehicleCategories(e) {
    return (Array.isArray(e) ? e.slice() : []).sort((e, t) => {
      const i = getVehicleCategorySortRank(e), n = getVehicleCategorySortRank(t);
      return i !== n ? i - n : String(e && e.categoryName || "").localeCompare(String(t && t.categoryName || ""));
    });
  }
  function Ae(e) {
    const t = ke(e), i = e && "object" == typeof e ? e.categoryName || e.title || "" : e;
    if (e && "object" == typeof e && e.navActiveIcon && e.navDefaultIcon) return {
      active: e.navActiveIcon,
      default: e.navDefaultIcon
    };
    const n = B[t] || E[i];
    return n && n.activeIcon && n.defaultIcon ? {
      active: n.activeIcon,
      default: n.defaultIcon
    } : C[t] || j;
  }
  function Le(e) {
    const t = s();
    let i = "";
    if (!e || -1 === e.indexOf(V)) return {
      queryCategory: i,
      filters: t
    };
    try {
      const n = new URL(e, window.location.origin), o = n.searchParams.get("q") || "", r = o ? o.split("_") : [], s = r.length > 4 && r[4] || "/", a = r.length > 5 && r[5] || "/", c = r.length > 7 && r[7] || "/";
      i = r[0] || "", t.bodyType = n.searchParams.get("body_type") || ([ "", "/" ].includes(a) ? "" : a), 
      t.trim = n.searchParams.get("trim") || ([ "", "/" ].includes(s) ? "" : s), t.qualifier = n.searchParams.get("qualifier") || ([ "", "/" ].includes(c) ? "" : c);
    } catch (e) {}
    return {
      queryCategory: i,
      filters: t
    };
  }
  function Ce(t, i, n) {
    const r = Object.assign(s(), i || {}), a = n && "object" == typeof n ? n : {};
    let c = e.getSourceUrlsForSelection(t, r);
    return !c.length && a.fallbackToAllEntries && (c = e.getSourceUrlsForSelection(t, s())), 
    o(c);
  }
  function je(e) {
    const t = String(e || "").trim();
    if (!t) return "";
    try {
      const e = new URL(t, window.location.origin);
      let i, n = String(e.pathname || "").replace(/\/{2,}/g, "/").replace(/\.js$/i, "");
      return n.length > 1 && (n = n.replace(/\/$/, "")), i = n.match(/^\/collections\/[^/]+\/products\/([^/?#]+)$/i), 
      i && i[1] ? `/products/${i[1]}` : 0 === n.indexOf("/collections/") || 0 === n.indexOf("/products/") ? n + (e.search || "") : "";
    } catch (e) {
      return "";
    }
  }
  function Me(t, i) {
    return e.buildDynamicLocationTargetUrl(t, i);
  }
  function Pe(e) {
    const t = document.getElementById("vehicle-title"), i = document.getElementById("breadcrumb-current");
    t && (window.innerWidth <= 768 ? t.textContent = e.replace(/\s*Accessories\s*&\s*Parts\s*$/i, "").trim() || e : t.textContent = e),
    i && (i.textContent = e), window.Auxito && window.Auxito.StaticVehicle && "function" == typeof window.Auxito.StaticVehicle.syncMobileLayoutOffset && requestAnimationFrame(() => {
      window.Auxito.StaticVehicle.syncMobileLayoutOffset(), window.setTimeout(window.Auxito.StaticVehicle.syncMobileLayoutOffset, 120);
    });
  }
  function Be(e, t, i) {
    const n = i && i.url ? String(i.url).trim() : "";
    return n || function(e) {
      const t = new URL(V, window.location.origin);
      return e.year && t.searchParams.set("year", String(e.year)), e.make && t.searchParams.set("make", String(e.make)), 
      e.model && t.searchParams.set("model", String(e.model)), e.categorySlug && t.searchParams.set("static_category", String(e.categorySlug)), 
      e.itemId && t.searchParams.set("static_item", String(e.itemId)), t.pathname + (t.search ? t.search : "") + t.hash;
    }({
      year: e.year,
      make: e.make,
      model: e.model,
      categorySlug: t.slug,
      itemId: i.id
    });
  }
  function Ee(e, t) {
    const i = new Map;
    return e.concat(t).forEach(e => {
      if (!(e && e.categoryName && Array.isArray(e.locations) && e.locations.length)) return;
      const t = ke(e), n = t || e.categoryName.toLowerCase();
      i.has(n) || i.set(n, {
        categoryName: e.categoryName,
        categorySlug: t,
        navActiveIcon: e.navActiveIcon || "",
        navDefaultIcon: e.navDefaultIcon || "",
        year: String(e.year || ""),
        make: e.make || "",
        model: e.model || "",
        subtitle: e.subtitle || "",
        locations: []
      });
      const o = i.get(n);
      !o.year && e.year && (o.year = String(e.year)), !o.make && e.make && (o.make = e.make), 
      !o.model && e.model && (o.model = e.model), !o.subtitle && e.subtitle && (o.subtitle = e.subtitle), 
      !o.categorySlug && t && (o.categorySlug = t), !o.navActiveIcon && e.navActiveIcon && (o.navActiveIcon = e.navActiveIcon), 
      !o.navDefaultIcon && e.navDefaultIcon && (o.navDefaultIcon = e.navDefaultIcon), 
      o.locations = function(e, t) {
        const i = new Map;
        return e.concat(t).forEach(e => {
          const t = String(e && e.location || "").trim().toLowerCase();
          if (!t) return;
          if (!i.has(t)) return void i.set(t, Object.assign({}, e));
          const n = i.get(t);
          !n.targetUrl && e.targetUrl && (n.targetUrl = e.targetUrl), !n.product && e.product && (n.product = e.product);
        }), Array.from(i.values());
      }(o.locations, e.locations);
    }), sortVehicleCategories(Array.from(i.values()));
  }
  function Te(e) {
    return String(e || "").trim().toLowerCase().replace(/\s+/g, " ");
  }
  function Ie(e, t, i) {
    const n = function(e, t) {
      const i = String(e || "").trim(), n = [ i ], o = x[i];
      o && !n.includes(o) && n.push(o), n.push(i.replace(/\s+/g, " ").trim(), i.replace(/\s*-\s*Off-road Use/gi, "").trim());
      for (let e = 0; e < n.length; e += 1) {
        const t = n[e];
        if (t && U[t]) return U[t];
      }
      return R[t] || N;
    }(e, t), o = function(e, t) {
      const i = Te(e), n = F[i], o = [];
      n && !o.includes(n) && o.push(n), i && !o.includes(i) && o.push(i);
      for (let e = 0; e < o.length; e += 1) {
        const i = o[e], n = i ? O[i] : null;
        if (n) return "mobile" === t ? n.mobile || n.desktop || "" : n.desktop || n.mobile || "";
      }
      return "";
    }(e, i);
    return o ? {
      image: o,
      thumb: n && n.thumb ? n.thumb : n && n.image || o
    } : n;
  }
  function Ue(e, t) {
    if (e && e.subtitle) {
      const i = _e({
        year: e.year || t && t.year,
        make: e.make || t && t.make,
        model: e.model || t && t.model
      });
      return i ? `${i} / ${e.subtitle}` : e.subtitle;
    }
    return _e({
      year: e.year || t && t.year,
      make: e.make || t && t.make,
      model: e.model || t && t.model
    });
  }
  function Oe() {
    return window.matchMedia(K).matches;
  }
  const Fe = "vehicle11-mobile-scroll-lock", MOBILE_ACTIVE_TOLERANCE = 48;
  let xe = null, $e = null, Ne = "", mobileNavLockedCategory = "";
  function Re() {
    if (function() {
      const e = Oe() && !!document.querySelector(".static-vehicle");
      document.documentElement && document.documentElement.classList.toggle(Fe, e), document.body && document.body.classList.toggle(Fe, e);
    }(), !Oe()) return;
    const e = document.querySelector(".static-vehicle"), t = document.querySelector(".static-vehicle__title-section");
    if (!e || !t) return;
    const h = document.querySelector(".site-header-wrapper"), headerH = Math.floor(Math.max(h ? Math.max(h.getBoundingClientRect().height, h.offsetHeight || 0) : 0, 80)) - 1;
    const i = t.getBoundingClientRect(), n = Math.max(0, Math.round(i.top)), o = Math.max(0, Math.ceil(t.offsetHeight)), r = Math.max(n + o, Math.ceil(i.bottom)), s = Math.max(0, Math.round(getMobileCategorySyncOffset()));
    e.style.setProperty("--sv-mobile-header-offset", `${n}px`), e.style.setProperty("--sv-mobile-title-height", `${o}px`),
    e.style.setProperty("--sv-mobile-layout-top", `${r}px`), e.style.setProperty("--sv-mobile-sticky-top", `${headerH}px`);
  }
  function getMobileCategorySyncOffset() {
    const e = document.querySelector(".site-header-wrapper");
    return Math.max((e ? Math.max(e.getBoundingClientRect().height, e.offsetHeight || 0) : 0) + 16, 96);
  }
  function getMobileContentOffset() {
    const t = document.querySelector(".static-vehicle__title-section");
    return getMobileCategorySyncOffset() + (t ? t.offsetHeight : 0);
  }
  function clearMobileNavLock(e) {
    (!e || e === mobileNavLockedCategory) && (mobileNavLockedCategory = "");
  }
  function lockMobileNavCategory(e) {
    mobileNavLockedCategory = String(e || "").trim();
  }
  function qe(e, t) {
    const i = t && "object" == typeof t ? t : {}, n = i.navScrollBehavior || "auto", o = Array.from(document.querySelectorAll(".static-vehicle__mobile-nav-item")), r = e || o[0] && o[0].getAttribute("data-mobile-category") || "";
    if (Ne = r, o.forEach(e => {
      e.classList.toggle("static-vehicle__mobile-nav-item--active", e.getAttribute("data-mobile-category") === r);
    }), !1 === i.keepNavInView || !r) return;
    const s = document.querySelector(`.static-vehicle__mobile-nav-item[data-mobile-category="${r}"]`);
    s && "function" == typeof s.scrollIntoView && s.scrollIntoView({
      block: "nearest",
      inline: "nearest",
      behavior: n
    });
  }
  function De() {
    if (!Oe()) return;
    const e = function() {
      const e = document.querySelector(".static-vehicle__mobile-content");
      if (!e) return "";
      const t = Array.from(e.querySelectorAll(".static-vehicle__mobile-category-section[data-mobile-category]"));
      if (!t.length) return "";
      const i = getMobileContentOffset() + MOBILE_ACTIVE_TOLERANCE;
      if (t[t.length - 1].getBoundingClientRect().bottom <= window.innerHeight) return t[t.length - 1].dataset.mobileCategory || "";
      let r = t[0].dataset.mobileCategory || "";
      for (let e = 0; e < t.length; e += 1) {
        const n = t[e];
        if (!(n.getBoundingClientRect().top <= i)) break;
        r = n.dataset.mobileCategory || r;
      }
      return r;
    }();
    if (mobileNavLockedCategory) {
      const t = mobileNavLockedCategory;
      return void qe(t, {
        navScrollBehavior: "auto",
        keepNavInView: !1
      });
    }
    e && e !== Ne && qe(e, {
      navScrollBehavior: "smooth",
      keepNavInView: !0
    });
  }
  function He() {
    xe && (window.cancelAnimationFrame(xe), xe = null), $e && ($e.disconnect(), $e = null);
  }
  function renderWithLockedMinHeight(e, t, i) {
    if ("function" != typeof t) return;
    if (!e) return void t();
    const n = Math.max(e.offsetHeight, Number(i) || 0);
    n > 0 && (e.style.minHeight = `${n}px`), t();
    var released = false;
    function releaseHeight() { if (released) return; released = true; e.style.removeProperty("min-height"); window.removeEventListener("scroll", releaseHeight); window.removeEventListener("click", releaseHeight); window.removeEventListener("touchstart", releaseHeight); }
    window.addEventListener("scroll", releaseHeight, { once: true, passive: true });
    window.addEventListener("click", releaseHeight, { once: true });
    window.addEventListener("touchstart", releaseHeight, { once: true, passive: true });
  }
  function getDesktopReservedGridColumns() {
    return window.innerWidth <= 480 ? 1 : window.innerWidth <= 900 ? 3 : window.innerWidth <= 1100 ? 4 : 5;
  }
  function estimateDesktopContentReservedHeight(e) {
    return Array.isArray(e) && e.length ? Math.max(2400, e.reduce(function(e, t, i) {
      const n = Array.isArray(t && t.locations) ? t.locations.length : 0, o = Math.max(1, Math.ceil(Math.max(1, n) / getDesktopReservedGridColumns())), r = 170 + 78 + 18 * Math.max(0, o - 1) + 292 * o;
      return e + r + (i > 0 ? 32 : 0);
    }, 0)) : 2400;
  }
  function estimateMobileContentReservedHeight(e) {
    const t = Math.max(window.innerHeight || 0, document.documentElement && document.documentElement.clientHeight || 0, 680);
    return Array.isArray(e) && e.length ? Math.max(Math.round(1.08 * t), e.reduce(function(e, t, i) {
      const n = Array.isArray(t && t.locations) ? t.locations.length : 0, o = 132 + 18 * Math.max(0, n - 1) + 228 * Math.max(1, n);
      return e + o + (i > 0 ? 28 : 0);
    }, 0)) : Math.round(1.08 * t);
  }
  function Ve(e, t) {
    const i = Math.max(1, Number(e) || 1), n = Math.max(1, Number(t) || 4);
    return `<div class="static-vehicle__loading-shell">${Array.from({
      length: i
    }).map(function(e, t) {
      return `\n        <div class="static-vehicle__loading-section" aria-hidden="true">\n          <div class="static-vehicle__loading-header">\n            <div class="static-vehicle__loading-heading"></div>\n            <div class="static-vehicle__loading-subheading"></div>\n          </div>\n          <div class="static-vehicle__loading-grid" data-loading-grid-index="${t}">\n            ${Array.from({
        length: n
      }).map(function() {
        return '\n              <div class="static-vehicle__loading-card" aria-hidden="true">\n                <div class="static-vehicle__loading-image"></div>\n                <div class="static-vehicle__loading-footer">\n                  <div class="static-vehicle__loading-line"></div>\n                  <div class="static-vehicle__loading-line static-vehicle__loading-line--short"></div>\n                </div>\n              </div>\n            ';
      }).join("")}\n          </div>\n        </div>\n      `;
    }).join("")}</div>`;
  }
  function Ke() {
    if (window.matchMedia && window.matchMedia(K).matches) return !1;
    const e = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    return !e || !e.saveData && !/^(slow-)?2g$/i.test(String(e.effectiveType || ""));
  }
  function We(e) {
    return e ? 0 === String(e).indexOf("//") ? "https:" + e : String(e) : "";
  }
  function Ge(e, t) {
    if (null == e || "" === e) return null;
    const i = Number(e);
    return Number.isFinite(i) ? t ? i / 100 : i : null;
  }
  function Xe(e) {
    for (let t = 0; t < re.length; t += 1) {
      const i = re[t];
      if (e.includes(i)) return "Build-in Fan" === i ? "Built-in Fan" : i;
    }
    return e.find(e => !se[e] && (!(/\b\d+(?:,\d+)?LM\b/i.test(e) || /\b\d+(?:\.\d+)?W\b/i.test(e) || /\b\d{4,5}K\b/i.test(e)) && e.length <= 28)) || "";
  }
  function Ye(e) {
    const t = [];
    return [ e.find(e => /\b\d+(?:,\d+)?LM\b/i.test(e)), e.find(e => /\b\d+(?:\.\d+)?W\b/i.test(e)), e.find(e => /\b\d{4,5}K\b/i.test(e) || /(White|Yellow|Amber|Blue|Red)/i.test(e)) ].forEach(e => {
      e && !t.includes(e) && t.push(e);
    }), t.slice(0, 3);
  }
  function ze(e, t) {
    if (!e || !e.handle) return null;
    const i = function(e) {
      return Array.isArray(e) ? e.map(e => String(e || "").trim()).filter(Boolean) : "string" == typeof e ? e.split(",").map(e => String(e || "").trim()).filter(Boolean) : [];
    }(e.tags), n = Array.isArray(e.variants) ? e.variants : [], o = n.find(e => e && e.available) || n[0] || null, r = o && null != o.price ? o.price : e.price, s = o && null != o.compare_at_price ? o.compare_at_price : e.compare_at_price;
    let a = "";
    if ("string" == typeof e.featured_image) a = We(e.featured_image); else if (e.featured_image && e.featured_image.src) a = We(e.featured_image.src); else if (Array.isArray(e.images) && e.images.length) {
      const t = e.images[0];
      a = We("string" == typeof t ? t : t && t.src);
    }
    return {
      id: e.id,
      handle: e.handle,
      url: "/products/" + e.handle,
      title: e.title || "",
      image: a,
      imageAlt: e.title || "",
      available: o ? !1 !== o.available : !1 !== e.available,
      variantId: o && o.id ? o.id : "",
      price: Ge(r, t.pricesAreCents),
      compareAtPrice: Ge(s, t.pricesAreCents),
      createdAt: e.created_at || "",
      tags: i,
      badge: Xe(i),
      specTags: Ye(i),
      sourceUrls: [ t.sourceUrl ]
    };
  }
  function Je(e, t) {
    const i = new URL(e, window.location.origin);
    return 0 !== i.pathname.indexOf("/collections/") ? null : (i.hash = "", i.searchParams.set("view", "search-result-data"), 
    t && t > 1 ? i.searchParams.set("page", String(t)) : i.searchParams.delete("page"), 
    i.toString());
  }
  async function Qe(e) {
    const t = await fetch(e, {
      credentials: "same-origin"
    });
    if (!t.ok) throw new Error(`Failed to fetch ${e}: ${t.status}`);
    return t.json();
  }
  function Ze(e, t) {
    if (!e || "object" != typeof e) return null;
    const i = Array.isArray(e.products) ? e.products : [], n = e.pagination && "object" == typeof e.pagination ? e.pagination : {};
    return {
      hasNextPage: !0 === n.has_next_page || !0 === n.hasNextPage,
      products: i.map(e => ze(e, {
        sourceUrl: t,
        pricesAreCents: !0
      })).filter(Boolean)
    };
  }
  async function et(e) {
    const t = String(e || "").trim();
    if (!t) return [];
    if (Z.has(t)) return Z.get(t);
    const i = he(D, t);
    if (i) {
      const e = Promise.resolve(i);
      return Z.set(t, e), e;
    }
    const n = async function() {
      try {
        const e = new URL(t, window.location.origin);
        let i = [];
        if (0 === e.pathname.indexOf("/products/")) {
          const n = new URL(e.pathname.replace(/\.js$/, "") + ".js", window.location.origin);
          i = [ ze(await Qe(n.toString()), {
            sourceUrl: t,
            pricesAreCents: !0
          }) ].filter(Boolean);
        } else 0 === e.pathname.indexOf("/collections/") && (i = await async function(e) {
          const t = [], i = new Set;
          let n = 1, o = !0;
          for (;o && n <= 40; ) {
            const r = Je(e, n);
            if (!r) break;
            const s = Ze(await Qe(r), e);
            if (!s) throw new Error("Invalid vehicle11 collection data view payload for " + e);
            const a = t.length;
            s.products.forEach((o, r) => {
              const s = String(o.handle || o.id || e + ":" + n + ":" + r);
              i.has(s) || (i.add(s), t.push(o));
            }), s.hasNextPage && t.length !== a ? n += 1 : o = !1;
          }
          return t;
        }(t));
        return pe(D, t, i), i;
      } catch (e) {
        console.warn("Failed to prefetch products for source:", t, e);
      }
      return [];
    }();
    return Z.set(t, n), n;
  }
  function tt(e, t) {
    if (!(e && Array.isArray(e.entries) && e.entries.length && t && -1 !== t.indexOf(V))) return null;
    const i = Le(t).filters, o = n(e.location);
    if (!o) return null;
    const r = Ce(e, i).slice(0, 3);
    if (!r.length) return null;
    // 键带上商品来源：原来只按「灯位 + 配置」存，换一台车看同一灯位会拿到上一台车的商品（2026-10-16）
    const s = o + "::" + [ i.bodyType || "", i.trim || "", i.qualifier || "" ].join("||") + "::" + r.join("|");
    return {
      identity: s,
      selectionKey: s,
      sourceUrls: r
    };
  }
  function it(e, t, i) {
    const hContext = window.AuxitoFitmentContext || null;
    if (!e) return null;
    const c = ye({
      year: t && t.year,
      make: t && t.make,
      model: t && t.model
    }) || ve(), l = t && t.categoryName ? String(t.categoryName).trim() : "", u = t && t.categorySlug ? String(t.categorySlug).trim() : ke(l), d = s(), f = String(e.location || "").trim(), g = n(f), m = function(e, t) {
      return o([ we(e) ].concat(Array.isArray(t) ? t.map(je) : []).filter(Boolean));
    }(u, [ t && t.staticResultsUrl ? t.staticResultsUrl : "", e && e.staticResultsUrl ? e.staticResultsUrl : "", je(i) ]).slice(0, hContext && hContext.MAX_SOURCE_URLS ? hContext.MAX_SOURCE_URLS : 3);
    let h = l && Object.prototype.hasOwnProperty.call(oe, l) ? oe[l] : "";
    if (!c || !u) return null;
    if ((!Array.isArray(e.entries) || !e.entries.length) && m.length) return {
      record: {
        kind: "static",
        queryCategory: "",
        categorySlug: u,
        locationKey: Se(u),
        location: l || f || "Universal Products"
      },
      query: {
        year: c.year,
        make: c.make,
        model: c.model
      },
      filters: d,
      sourceUrls: m,
      handles: a((i ? [ i ] : []).concat(m))
    };
    if (!(f && g && Array.isArray(e.entries) && e.entries.length)) return null;
    if (i && -1 !== i.indexOf(V)) {
      const e = Le(i);
      h = e.queryCategory || h, d.bodyType = e.filters.bodyType, d.trim = e.filters.trim, 
      d.qualifier = e.filters.qualifier;
    }
    if (!h) return null;
    const p = Ce(e, d, {
      fallbackToAllEntries: !0
    }).slice(0, hContext && hContext.MAX_SOURCE_URLS ? hContext.MAX_SOURCE_URLS : 3);
    return p.length ? {
      record: {
        kind: "dynamic",
        queryCategory: h,
        categorySlug: u,
        locationKey: r(h, g),
        location: f
      },
      query: {
        category: h,
        year: c.year,
        make: c.make,
        model: c.model
      },
      filters: d,
      sourceUrls: p,
      handles: a((i ? [ i ] : []).concat(p))
    } : null;
  }
  async function nt(e) {
    if (!(e && e.selectionKey && e.sourceUrls && e.sourceUrls.length)) return [];
    if (ee.has(e.selectionKey)) return ee.get(e.selectionKey);
    const t = he(H, e.selectionKey);
    if (t) {
      const i = Promise.resolve(t);
      return ee.set(e.selectionKey, i), i;
    }
    const i = async function() {
      const t = await Promise.all(e.sourceUrls.map(et)), i = new Map;
      t.forEach((t, n) => {
        const r = e.sourceUrls[n];
        t.forEach((e, t) => {
          const n = String(e.handle || e.id || r + ":" + t);
          if (!i.has(n)) return void i.set(n, e);
          const s = i.get(n);
          s.sourceUrls = o((s.sourceUrls || []).concat(e.sourceUrls || []));
        });
      });
      const n = Array.from(i.values());
      return pe(H, e.selectionKey, n), n;
    }();
    return ee.set(e.selectionKey, i), i;
  }
  async function ot(e) {
    return (await Promise.all((e || []).map(async e => {
      if (!e || !Array.isArray(e.locations) || !e.locations.length) return null;
      const t = await async function(e) {
        return (await Promise.all((e || []).map(async e => {
          const t = tt(e, e && e.targetUrl ? e.targetUrl : "");
          if (!e) return null;
          if (!t) return e;
          try {
            const i = await nt(t);
            return Array.isArray(i) && i.length ? e : null;
          } catch (t) {
            return console.warn("Failed to validate vehicle11 location availability:", t), e;
          }
        }))).filter(Boolean);
      }(e.locations);
      return t.length ? Object.assign({}, e, {
        locations: t
      }) : null;
    }))).filter(Boolean);
  }
  function rt(e) {
    e && te.has(e) && (window.clearTimeout(te.get(e)), te.delete(e));
  }
  function st(e, t) {
    if (!Ke() || !e) return;
    rt(e);
    const i = window.setTimeout(() => {
      te.delete(e), document.body.contains(e) && function(e) {
        if (!Ke() || !e) return;
        const t = e.getAttribute("data-prefetch-key");
        if (!t) return;
        const i = z.get(t);
        i && !Q.has(i.identity) && (Q.add(i.identity), nt(i).catch(() => {
          Q.delete(i.identity);
        }));
      }(e);
    }, Math.max(0, t || 0));
    te.set(e, i);
  }
  function at(e, t, i, n) {
    const o = function(e, t, i) {
      return function(e, t) {
        if (!e || !e.image && !e.mobileImage) return null;
        const i = "mobile" === t ? e.mobileImage || e.image || "" : e.image || e.mobileImage || "";
        return i ? {
          image: i,
          thumb: i
        } : null;
      }(e, i) || function(e, t) {
        const i = e && e.product;
        if (!i || !i.images) return null;
        const n = i.images[t] || i.images.desktop || {}, o = n.main || n.image || n.large || "", r = n.thumbnail || n.thumb || o;
        return o ? {
          image: o,
          thumb: r || o
        } : null;
      }(e, i) || Ie(e && e.location, t, i);
    }(e, t && t.categoryName ? t.categoryName : "", i), r = ae(e && e.location || "View products"), s = e && (e.targetUrl || e.product && e.product.url) || "", a = ae(s), c = function(e, t) {
      const i = tt(e, t);
      if (!i) return "";
      X += 1;
      const n = "prefetch-" + X;
      return z.set(n, i), n;
    }(e, s), l = function(e, t, i) {
      const n = it(e, t, i);
      if (!n) return "";
      Y += 1;
      const o = "fitment-" + Y;
      return J.set(o, n), o;
    }(e, t, s), u = c ? ` data-prefetch-key="${ae(c)}"` : "", d = l ? ` data-fitment-key="${ae(l)}"` : "";
    return `\n      <article class="static-vehicle__product-card"${a ? ` data-target-url="${a}" data-location-label="${r}"${u}${d} role="link" tabindex="0"` : ""}>\n        <div class="static-vehicle__product-image">\n          ${le(o.image, r, n)}\n        </div>\n        <div class="static-vehicle__product-copy">\n          <h3 class="static-vehicle__product-name">${r}</h3>\n        </div>\n      </article>\n    `;
  }
  function ct() {
    const e = document.getElementById("static-sections");
    e && (e.innerHTML = "", e.style.display = "none");
  }
  function lt(e) {
    const t = document.getElementById("static-vehicle-nav"), i = document.querySelector(".static-vehicle__secondary-nav");
    t && i && (i.style.display = e.length ? "" : "none", t.innerHTML = e.map((e, t) => {
      const i = ke(e), n = Ae(e), o = 0 === t ? " static-vehicle__nav-item--active" : "", r = ae(e.categoryName);
      return `\n          <div class="static-vehicle__nav-item${o}" data-category="${i}" onclick="window.Auxito.StaticVehicle.scrollToSection('${i}-section', this)">\n            <div class="static-vehicle__nav-icon">\n              <img src="${n.active}" alt="${r}" class="static-vehicle__nav-icon-active">\n              <img src="${n.default}" alt="${r}" class="static-vehicle__nav-icon-default">\n            </div>\n            <span class="static-vehicle__nav-text">${r}</span>\n          </div>\n        `;
    }).join(""));
  }
  function ut(e, t) {
    const i = document.querySelector(".static-vehicle__mobile-sidebar"), n = document.querySelector(".static-vehicle__mobile-content");
    if (!i || !n) return;
    clearMobileNavLock();
    const o = e.length ? ke(e[0]) : "";
    i.innerHTML = e.map((e, t) => {
      const i = ke(e), n = Ae(e), o = 0 === t ? " static-vehicle__mobile-nav-item--active" : "", r = ae(e.categoryName);
      return `\n          <div class="static-vehicle__mobile-nav-item${o}" data-mobile-category="${i}" onclick="window.Auxito.StaticVehicle.switchMobileCategory('${i}', this)">\n            <div class="static-vehicle__mobile-nav-icon">\n              <img src="${n.active}" alt="${r}" class="static-vehicle__mobile-nav-icon-active">\n              <img src="${n.default}" alt="${r}" class="static-vehicle__mobile-nav-icon-default">\n            </div>\n            <span class="static-vehicle__mobile-nav-text">${r}</span>\n          </div>\n        `;
    }).join(""), n.innerHTML = e.map((e, i) => {
      const n = ke(e);
      return `\n          <div class="static-vehicle__mobile-category-section" id="mobile-${n}-section" data-mobile-category="${n}">\n            <div class="static-vehicle__mobile-category-header">\n              <h2 class="static-vehicle__mobile-category-title">${ae(e.categoryName)}</h2>\n              <p class="static-vehicle__mobile-category-subtitle">${ae(Ue(e, t))}</p>\n            </div>\n            <div class="static-vehicle__mobile-products-grid">\n              ${e.locations.map((t, n) => at(t, e, "mobile", ge("mobile", i, n))).join("")}\n            </div>\n          </div>\n        `;
    }).join(""), i.scrollTop = 0, n.scrollTop = 0, me(document), function() {
      const e = document.querySelector(".static-vehicle__mobile-content");
      if (e) {
        if (He(), window.IntersectionObserver) {
          const t = e.querySelectorAll(".static-vehicle__mobile-category-section[data-mobile-category]");
          if (!t.length) return;
          return $e = new IntersectionObserver(() => {
            De();
          }, {
            root: null,
            rootMargin: "-18% 0px -52% 0px",
            threshold: [ 0, .08, .2, .4, .65, 1 ]
          }), t.forEach(e => {
            $e.observe(e);
          }), void De();
        }
      }
    }(), requestAnimationFrame(() => {
      qe(o, {
        keepNavInView: !1
      }), Re(), De();
    });
  }
  function dt(e, t) {
    const i = ae(t);
    W = null, G = "", X = 0, Y = 0, z.clear(), J.clear(), ct(), lt([]), Pe(be(e || {}));
    const n = document.getElementById("desktop-content");
    n && renderWithLockedMinHeight(n, function() { n.removeAttribute("data-loading-state"); n.innerHTML = `\n        <div class="static-vehicle__category-section">\n          <div class="static-vehicle__category-header">\n            <h2 class="static-vehicle__category-title">No results</h2>\n            <p class="static-vehicle__category-subtitle">${i}</p>\n          </div>\n        </div>\n      `; n.style.display = "block"; });
    const o = document.querySelector(".static-vehicle__mobile-sidebar"), r = document.querySelector(".static-vehicle__mobile-content");
    o && (o.scrollTop = 0, o.innerHTML = ""), r && (He(), Ne = "", r.scrollTop = 0,
    renderWithLockedMinHeight(r, function() { r.removeAttribute("data-loading-state"); r.innerHTML = `\n        <div class="static-vehicle__mobile-category-section">\n          <div class="static-vehicle__mobile-category-header">\n            <h2 class="static-vehicle__mobile-category-title">No results</h2>\n            <p class="static-vehicle__mobile-category-subtitle">${i}</p>\n          </div>\n        </div>\n      `; })),
    requestAnimationFrame(Re), window.Auxito && window.Auxito.StaticVehicle && "function" == typeof window.Auxito.StaticVehicle.refreshPageScrollCache && requestAnimationFrame(() => {
      window.Auxito.StaticVehicle.refreshPageScrollCache();
    });
  }
  function ft(e, t) {
    const i = estimateDesktopContentReservedHeight(e), n = estimateMobileContentReservedHeight(e);
    Pe(be(t)), ct(), X = 0, Y = 0, z.clear(), J.clear(), lt(e), Oe() ? (!function() {
      const e = document.getElementById("desktop-content");
      e && (e.innerHTML = "", e.style.display = "none", e.removeAttribute("data-loading-state"), e.style.removeProperty("min-height"));
    }(), renderWithLockedMinHeight(document.querySelector(".static-vehicle__mobile-content"), function() {
      ut(e, t);
      const i = document.querySelector(".static-vehicle__mobile-content");
      i && i.removeAttribute("data-loading-state");
    }, n), G = "mobile") : (!function() {
      const e = document.querySelector(".static-vehicle__mobile-sidebar"), t = document.querySelector(".static-vehicle__mobile-content");
      He(), Ne = "", e && (e.scrollTop = 0, e.innerHTML = ""), t && (t.scrollTop = 0, 
      t.innerHTML = "", t.removeAttribute("data-loading-state"), t.style.removeProperty("min-height"));
    }(), renderWithLockedMinHeight(document.getElementById("desktop-content"), function() {
      const i = document.getElementById("desktop-content");
      i && (i.innerHTML = e.map((e, i) => `\n          <div class="static-vehicle__category-section" id="${ke(e)}-section">\n            <div class="static-vehicle__category-header">\n              <h2 class="static-vehicle__category-title">${ae(e.categoryName)}</h2>\n              <p class="static-vehicle__category-subtitle">${ae(Ue(e, t))}</p>\n            </div>\n            <div class="static-vehicle__products-grid">\n              ${e.locations.map((t, n) => at(t, e, "desktop", ge("desktop", i, n))).join("")}\n            </div>\n          </div>\n        `).join(""), 
      me(i), i.style.display = "block", i.removeAttribute("data-loading-state"));
    }, i), G = "desktop"), W = {
      categories: e,
      vehicle: t
    }, requestAnimationFrame(Re), window.Auxito && window.Auxito.StaticVehicle && "function" == typeof window.Auxito.StaticVehicle.refreshPageScrollCache && requestAnimationFrame(() => {
      window.Auxito.StaticVehicle.refreshPageScrollCache();
    });
  }
  // 已上线新车型页的车（车型索引里有年份页）直接进 03 年份页，旧车型页只留给其他车型（运营 2026-10-29）。网址里的 utm / apsp_test 等参数原样带上。
  function redirectLaunched(v) {
    if (window.Shopify && window.Shopify.designMode) return false;
    const yh = launchedYearPage(v);
    if (!yh) return false;
    const q = new URLSearchParams(window.location.search);
    [ "year", "make", "model" ].forEach(k => q.delete(k));
    const qs = q.toString();
    window.location.replace("/pages/vehicle-year/" + encodeURIComponent(yh) + (qs ? "?" + qs : ""));
    return true;
  }
  // Exterior / Interior Accessories 在车型库里每台车都只有同一个通用集合（不分车型），点进去会看到别的车的配件（运营 2026-10-29）。
  // 没有上线新车型页的车按商品「品牌 车型」标签（如 Honda Civic，与 03 分类卡同一取法：品牌 + 车型第一个词）筛分类集合，
  // 该标签下有商品才显示卡片，没有就去掉；标签不带年份，同车系各年份的商品都会列出。
  const ACCESSORY_COLLECTIONS = {
    "Exterior Accessories": "exterior-body",
    "Interior Accessories": "interior-controls"
  };
  function launchedYearPage(v) {
    if (!v) return "";
    let list = [];
    try {
      const el = document.querySelector("script[data-static-vehicle-launched]");
      list = el ? JSON.parse(el.textContent || "[]") : [];
    } catch (e) {}
    const lc = x => String(x || "").trim().toLowerCase(), y = lc(v.year), mk = lc(v.make), m = lc(v.model);
    const hit = list.find(x => lc(x.y) === y && lc(x.mk) === mk && (lc(x.m) === m || lc(x.l) === m));
    return hit && hit.yh ? String(hit.yh) : "";
  }
  // 车型标签候选：品牌 + 车型第一个词（与 03 分类卡同一取法，如 Honda Civic），再试车型前两个词与完整车型（Jeep Grand Cherokee、Toyota Land Cruiser）
  function vehicleTagHandles(v) {
    const hz = x => String(x || "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
    const make = String(v && v.make || "").trim(), words = String(v && v.model || "").trim().split(/\s+/).filter(Boolean);
    if (!make || !words.length) return [];
    return [ words.slice(0, 1), words.slice(0, 2), words ].map(w => hz(make + " " + w.join(" "))).filter((x, i, a) => a.indexOf(x) === i);
  }
  // 集合模板 collection.category-index 每个商品第 3 项 = 是否带网址里的标签（店里没有这个标签时 Shopify 忽略标签、返回整个集合，不能只看有没有商品）
  async function tagCollectionUrl(handle, tags) {
    if (!handle || !tags.length) return "";
    const hits = await Promise.all(tags.map(async tag => {
      const url = "/collections/" + handle + "/" + tag;
      try {
        const r = await fetch(url + "?view=category-index", {
          credentials: "same-origin"
        });
        if (!r.ok) return "";
        const d = await r.json();
        return d && Array.isArray(d.products) && d.products.some(x => x && x[2] === 1) ? url : "";
      } catch (e) {
        return "";
      }
    }));
    return hits.find(Boolean) || "";
  }
  async function applyAccessoryFit(categories, v) {
    if (!Array.isArray(categories)) return categories;
    const isAcc = l => l && Object.prototype.hasOwnProperty.call(ACCESSORY_COLLECTIONS, String(l.location || "").trim());
    if (!categories.some(c => c && Array.isArray(c.locations) && c.locations.some(isAcc))) return categories;
    const tags = vehicleTagHandles(v), urls = {};
    await Promise.all(Object.keys(ACCESSORY_COLLECTIONS).map(async k => {
      urls[k] = await tagCollectionUrl(ACCESSORY_COLLECTIONS[k], tags);
    }));
    return categories.map(c => {
      if (!c || !Array.isArray(c.locations) || !c.locations.some(isAcc)) return c;
      const locations = c.locations.map(l => {
        if (!isAcc(l)) return l;
        const u = urls[String(l.location).trim()];
        // from=vehicle-page：集合页据此显示二级 / 三级类目筛选（auxito-collection-category-filter.js，运营 2026-10-31）；
        // view=view-48 与 03 / 04 分类卡相同，一页显示 48 件，类目筛选不用翻页（筛选只作用于已加载的商品）
        return u ? Object.assign({}, l, {
          targetUrl: u + (u.indexOf("?") > -1 ? "&" : "?") + "view=view-48&from=vehicle-page",
          entries: []
        }) : null;
      }).filter(Boolean);
      return locations.length ? Object.assign({}, c, {
        locations: locations
      }) : null;
    }).filter(Boolean);
  }
  function gt() {
    if ("true" === document.documentElement.dataset.vehicle11CardNavigationBound) return;
    document.documentElement.dataset.vehicle11CardNavigationBound = "true";
    const e = e => e && "function" == typeof e.closest ? e.closest(".static-vehicle__product-card[data-target-url], .static-vehicle__product-card[data-product-url]") : null, t = e => {
      const t = e.getAttribute("data-target-url") || e.getAttribute("data-product-url");
      if (t) {
        let n = t;
        const o = e.getAttribute("data-location-label"), r = e.getAttribute("data-fitment-key") || "", s = r ? J.get(r) : null;
        if (o && -1 !== t.indexOf("/pages/search-result")) {
          const e = new URL(t, window.location.origin);
          e.searchParams.set("location_label", o), n = `${e.pathname}${e.search}${e.hash}`;
        }
        !function(e) {
          const t = ye(e), i = window.AuxitoVehicleUtils || null, n = i && "function" == typeof i.getVehicleStorage ? i.getVehicleStorage() : (window.Auxito && window.Auxito.Vehicle && window.Auxito.Vehicle.Storage);
          if (t && n && "function" == typeof n.addVehicle) try {
            n.addVehicle({
              year: t.year,
              make: t.make,
              model: t.model,
              display: _e(t)
            }), i && "function" == typeof i.syncVehicleStorageUi ? i.syncVehicleStorageUi({
              showSelectedState: !0
            }) : window.Auxito && window.Auxito.Vehicle && window.Auxito.Vehicle.Selector && "function" == typeof window.Auxito.Vehicle.Selector.syncVehicleStorageState && window.Auxito.Vehicle.Selector.syncVehicleStorageState({
              showSelectedState: !0
            });
          } catch (e) {
            console.warn("Failed to sync vehicle11 vehicle context:", e);
          }
        }(ve()), i = s;
        const hContext = window.AuxitoFitmentContext || null;
        hContext && "function" == typeof hContext.writeSelection && i && hContext.writeSelection(i), 
        window.location.href = n;
      }
      var i;
    };
    document.addEventListener("click", i => {
      const n = e(i.target);
      n && t(n);
    }), document.addEventListener("mouseover", t => {
      const i = e(t.target);
      if (!i) return;
      e(t.relatedTarget) !== i && st(i, 180);
    }), document.addEventListener("mouseout", t => {
      const i = e(t.target);
      if (!i) return;
      e(t.relatedTarget) !== i && rt(i);
    }), document.addEventListener("focusin", t => {
      const i = e(t.target);
      i && st(i, 120);
    }), document.addEventListener("focusout", t => {
      const i = e(t.target);
      i && rt(i);
    }), document.addEventListener("keydown", i => {
      if ("Enter" !== i.key && " " !== i.key) return;
      const n = e(i.target);
      n && (i.preventDefault(), t(n));
    });
  }
  async function mt() {
    gt(), function() {
      if ("true" === document.documentElement.dataset.vehicle11ViewportBound) return;
      document.documentElement.dataset.vehicle11ViewportBound = "true";
      let e = null;
      window.addEventListener("resize", () => {
        W && (clearTimeout(e), e = setTimeout(() => {
          (Oe() ? "mobile" : "desktop") !== G && ft(W.categories, W.vehicle);
        }, 120));
      }, {
        passive: !0
      });
    }();
    const t = ve();
    if (!t) return void dt(null, "Select a vehicle to load fitment results.");
    if (redirectLaunched(t)) return;
    !function(e) {
      W = null, G = "", X = 0, z.clear(), Pe(be(e || {})), ct();
      const t = document.getElementById("desktop-content");
      t && (t.setAttribute("data-loading-state", "loading"), t.innerHTML = Ve(3, 8), t.style.display = "block");
      const i = document.querySelector(".static-vehicle__mobile-sidebar");
      i && (i.scrollTop = 0, i.innerHTML = '\n        <div class="static-vehicle__mobile-loading-sidebar" aria-hidden="true">\n          <div class="static-vehicle__loading-line"></div>\n          <div class="static-vehicle__loading-line"></div>\n          <div class="static-vehicle__loading-line static-vehicle__loading-line--short"></div>\n        </div>\n      ');
      const n = document.querySelector(".static-vehicle__mobile-content");
      n && (He(), Ne = "", n.scrollTop = 0, n.setAttribute("data-loading-state", "loading"), n.innerHTML = Ve(3, 6)), requestAnimationFrame(Re);
    }(t);
    const i = async function(t) {
      return e.fetchDynamicFitmentYearData(t, k);
    }(t.year).then(i => function(t, i) {
      return e.buildDynamicSidebarGroups(t, i).map(e => {
        const t = String(e && e.title || "").trim();
        if (!t) return null;
        const n = ke(t), o = Ae({
          categoryName: t,
          categorySlug: n
        }), r = (e.items || []).map(e => e && e.queryCategory && Array.isArray(e.entries) && e.entries.length ? {
          location: e.location,
          targetUrl: Me(e, i),
          entries: e.entries
        } : null).filter(Boolean);
        return r.length ? {
          categoryName: t,
          categorySlug: n,
          navActiveIcon: o.active,
          navDefaultIcon: o.default,
          year: String(i.year || ""),
          make: String(i.make || ""),
          model: String(i.model || ""),
          locations: r
        } : null;
      }).filter(Boolean);
    }(i, t)).catch(e => (console.warn("Failed to load fitment data for vehicle11:", e), 
    [])), n = await applyAccessoryFit(await i, t), o = await ot(Ee(Array.isArray(n) ? n : [], function(e) {
      return v.categories.filter(e => T.includes(e.slug) && !g.includes(e.slug)).map(t => {
        const i = Array.isArray(t.cards) ? t.cards : [];
        return i.length ? {
          categoryName: t.title,
          categorySlug: t.slug,
          navActiveIcon: t.activeIcon || Ae({
            slug: t.slug,
            title: t.title
          }).active,
          navDefaultIcon: t.defaultIcon || Ae({
            slug: t.slug,
            title: t.title
          }).default,
          subtitle: t.subtitle || "Universal",
          staticCategorySlug: t.slug,
          year: e.year,
          make: e.make,
          model: e.model,
          locations: i.map(i => ({
            location: i.location,
            targetUrl: Be(e, t, i),
            image: i.image,
            mobileImage: i.mobileImage,
            staticCardId: i.id,
            staticCategorySlug: t.slug,
            staticResultsUrl: we(t.slug) || je(i.url) || ""
          }))
        } : null;
      }).filter(Boolean);
    }(t)));
    o.length ? ft(o, t) : dt(t, "No fitment data is available for this vehicle yet.");
  }
  window.Auxito=window.Auxito || {}, window.Auxito.StaticVehicle=window.Auxito.StaticVehicle || {}, 
  "true" !== document.documentElement.dataset.vehicle11MobileLayoutBound && (document.documentElement.dataset.vehicle11MobileLayoutBound = "true", 
  window.Auxito.StaticVehicle.syncMobileLayoutOffset = Re, window.addEventListener("resize", () => {
    window.setTimeout(() => {
      Re(), De();
    }, 40);
  }, {
    passive: !0
  }), window.addEventListener("orientationchange", () => {
    window.setTimeout(() => {
      Re(), De();
    }, 80);
  }, {
    passive: !0
  }), window.addEventListener("scroll", () => {
    xe || (xe = requestAnimationFrame(() => {
      xe = null, Re(), De();
    }));
  }, {
    passive: !0
  })), window.Auxito.StaticVehicle.switchMobileCategory = (e, t, i) => {
    const n = i && "object" == typeof i ? i : {}, o = document.querySelector(".static-vehicle__mobile-content"), r = document.getElementById(`mobile-${e}-section`);
    lockMobileNavCategory(e), qe(e, {
      navScrollBehavior: n.navScrollBehavior || "smooth"
    }), o && r && requestAnimationFrame(() => {
      const t = Math.max(0, window.pageYOffset + r.getBoundingClientRect().top - getMobileContentOffset());
      window.scrollTo({
        top: t,
        behavior: n.behavior || "smooth"
      });
    });
  }, window.addEventListener("touchstart", () => {
    clearMobileNavLock();
  }, {
    passive: !0
  }), window.addEventListener("wheel", () => {
    clearMobileNavLock();
  }, {
    passive: !0
  }), window.addEventListener("keydown", e => {
    /^(ArrowDown|ArrowUp|PageDown|PageUp|Home|End|Space)$/.test(e.key || "") && clearMobileNavLock();
  });
  const ht = () => {
    mt().catch(e => {
      console.error("Vehicle11 real-data renderer failed:", e), dt(ve(), "Vehicle data could not be loaded right now.");
    });
  };
  "loading" === document.readyState ? document.addEventListener("DOMContentLoaded", ht) : ht();
}();
